<script>
import _ from 'lodash'

import imgAlertCircle from '../assets/alert-circle.svg'

export default {
	lang: 'books',
	inject: ['editor'],
	data() {
		return {
			tabIndex: -1,
			imgAlertCircle,
		}
	},
	computed: {
		e() {
			return this.editor()
		},
		tabs() {
			const data = this.e.customization.data
			const { $lang } = this
			return [
				{
					title: $lang('Nombre'),
					get value() {
						return data.name
					},
					incompleteValue: $lang('Completa los datos'),
					get complete() {
						return data.name && data.name2 && data.gender && data.date && data.lang
					},
				},
				{
					title: $lang('Dedicatoria'),
					get value() {
						return data.inscription
					},
					incompleteValue: $lang('Escribe una dedicatoria'),
					get complete() {
						return data.inscription
					},
				},
			]
		},
		dataChecker() {
			let data = this.e.customization.data
			let checker = _.pick(data, ['name', 'name2', 'gender', 'date', 'lang', 'inscription'])
			return JSON.stringify(checker)
		},
	},
}
</script>

<template>
	<BookEditor-Tabs :tabs="tabs" :data-checker="dataChecker" v-model="tabIndex">
		<template #item1>
			<div class="pr-md-6 w100">
				<BookEditorInput-TextField
					model-key="name"
					:label="$lang('Este libro personalizado es para')"
					:placeholder="$lang('Nombre')"
				/>
				<BookEditorInput-TextField
					model-key="name2"
					:label="$lang('Este libro personalizado es de parte de')"
					:placeholder="$lang('Nombre')"
				/>
				<BookEditorInput-DatePicker model-key="date" :label="$lang('Fecha de la comunión')" />
			</div>
			<div class="pt-4 pt-md-0 w100">
				<BookEditorInput-LangSelect />
				<BookEditorInput-GenderCharacters />
			</div>
		</template>
		<template #item2>
			<BookEditorTab-Inscription />
		</template>
	</BookEditor-Tabs>
</template>

<style lang="scss" scoped>
.zodiac {
	position: relative;
}
.zodiac__info-icon {
	position: absolute;
	cursor: pointer;
	transition: all 0.3s;
	left: 50%;
	transform: translateX(46px);
	bottom: 10px;
	&:hover {
		transform-origin: center;
		transform: translateX(46px) scale(1.2);
	}
}
.zodiac-info-alert {
	max-width: 360px;
}
</style>
